<template>
    <div id="zhujian">
        <slider :platInfo = platInfo></slider>
    </div>
</template>

<script>
    import slider from '../../components/slider.vue'
    export default {
        name: "zhujian",
        components:{slider},
        data() {
            return {
                swiper: null,
                platInfo:zhujianInfo,
            }
        },
        methods: {},
        mounted() {

        }
    }
</script>

<style lang="css" scoped>
    #zhujian{
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: row;
        background: linear-gradient(to right,#C1F2F9,#fff,#C1F2F9);;
    }
</style>



// WEBPACK FOOTER //
// src/views/zhujian/zhujian.vue